import React from 'react';

import { css, StyleSheet } from 'aphrodite';

import BrandOutlierCleanupStatsSection from 'components/manage_brands/brand_stats_dashboard/BrandOutlierCleanupStatsSection';
import BrandStatsDashboardBanner from 'components/manage_brands/brand_stats_dashboard/BrandStatsDashboardBanner';
import BrandVerificationStatsSection from 'components/manage_brands/brand_stats_dashboard/BrandVerificationStatsSection';
import { BRAND_PRODUCT_OUTLIER_CLEANUP_STATS } from 'lib/networking/endpoints';
import Container from 'components/shared/Container';
import RecurringJobsSection from 'components/manage_brands/brand_stats_dashboard/RecurringJobsSection';
import useGet from 'lib/hooks/useGet';

function BrandStatsDashboardView() {
  const { data: { counts: outlierCleanupCounts = {} } = {}, loading: outlierCleanupLoading } =
    useGet(BRAND_PRODUCT_OUTLIER_CLEANUP_STATS);

  return (
    <>
      <BrandStatsDashboardBanner />
      <Container className={css(styles.pageContainer)}>
        <BrandVerificationStatsSection />
        <BrandOutlierCleanupStatsSection
          counts={outlierCleanupCounts}
          loading={outlierCleanupLoading}
        />
        <RecurringJobsSection />
      </Container>
    </>
  );
}

const styles = StyleSheet.create({
  pageContainer: {
    padding: '20px',
  },
});

export default BrandStatsDashboardView;
